import { useState } from "react";
import { useDispatch } from "react-redux";

import PatientDetailsPageUserInfo from "../PatientDetailsPageUserInfo/PatientDetailsPageUserInfo";
import PatientDetailsPageAppsList from "../PatientDetailsPageAppsList/PatientDetailsPageAppsList";
import PatientDetailsPageDentalFormList from "../PatientDetailsPageDentalFormList/PatientDetailsPageDentalFormList";
import PatientDetailsPagePhotos from "../PatientDetailsPagePhotos/PatientDetailsPagePhotos";
import { setIsVisibleDentalFormulaModal } from "@/store/ui/ui";
import { categotiesInheader } from "@/utils/constants";

import { ISelectedpatientProps } from "@/shared/interfaces/patientPage";

import "./PatientDetailsPageMain.scss";
import AddFormulaButton from "@/shared/components/AddFormulaButton/AddFormulaButton";

export default function PatientDetailsPageMain({
    toggleDrawer,
}: ISelectedpatientProps) {
    const [activeCategory, setActiveCategory] = useState("info");
    const dispatch = useDispatch();

    function renderContent() {
        switch (activeCategory) {
            case "appointments":
                return <PatientDetailsPageAppsList />;
            case "tooth_formulas":
                return <PatientDetailsPageDentalFormList />;
            case "photos":
                return <PatientDetailsPagePhotos />;
            case "info":
            default:
                return (
                    <PatientDetailsPageUserInfo toggleDrawer={toggleDrawer} />
                );
        }
    }

    return (
        <main className='main_content_container container-in-patient-detail-page'>
            <section className='header_in_main_content'>
                <div className='header_selector'>
                    {categotiesInheader.map(category => (
                        <p
                            key={category.id}
                            className={
                                activeCategory === category.id
                                    ? "active_category"
                                    : ""
                            }
                            id={category.id}
                            onClick={() => setActiveCategory(category.id)}
                        >
                            {category.name}
                        </p>
                    ))}
                </div>
                <AddFormulaButton
                    onClick={() =>
                        dispatch(setIsVisibleDentalFormulaModal(true))
                    }
                />
            </section>
            {renderContent()}
        </main>
    );
}
